import { DialogTitle, Typography, paperClasses, styled, DialogActions as MuiDialogActions } from '@mui/material'

import { ModalDialog as UnstyledDialog, DialogContent as UnstyledDialogContent } from '../../utils/shared/Modal'

export const Title = styled(DialogTitle)({
  fontSize: 17,
  lineHeight: '22.1px',
  letterSpacing: 0.15,
  textAlign: 'center',
  margin: '0 auto',
  paddingBottom: 0,
})

export const Description = styled(Typography)({
  fontSize: 13,
  lineHeight: '16.9px',
  letterSpacing: 0.4,
  textAlign: 'center',
  margin: '0 auto',
  paddingLeft: 0,
  paddingRight: 0,
})

export const DialogActions = styled(MuiDialogActions)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
})

export const DialogContent = styled(UnstyledDialogContent)({
  paddingBottom: 0,
  marginTop: 24,
  marginBottom: 36,
})

export const Dialog = styled(UnstyledDialog)({
  [`.${paperClasses.root}`]: {
    padding: '36px 28px',
  },
})
